import React, { useState } from 'react'
import { Breadcrumb, Button, Card, Row, Col } from '@themesberg/react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAddressCard, faExclamation, faHome } from '@fortawesome/free-solid-svg-icons';
import { Form, Input, Modal, Button as AntButton, Table, Space, Tag, Upload, Select, Empty } from 'antd';
import { InboxOutlined } from '@ant-design/icons'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { createBlogs, updateBlogTop, updateFeature } from '../../../services/apiCalls';
import AlertToast from '../../../components/AlertToast';
import { blogAlert, blogResponse, features, blogList, blogRefresh } from '../../../states/blogs';
import { dummyRequest, getHtml, getRawData } from '../../../services/utilities';
import { imageUrl } from '../../../services/axios';
import BlogCardHome from './BlogCardHome';
import { Editor } from 'react-draft-wysiwyg';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState } from 'draft-js';

const BlogIndex = () => {
  // const data = useRecoilValueLoadable(features)
  const blogs = useRecoilValue(blogList)
  const [viewModal, setViewModal] = useState(false)
  const [viewTopModal, setViewTopModal] = useState(false)
  const [editModal, setEditModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [value, setValue] = useState({})
  const [file, setFile] = useState("")
  const [editor, setEditor] = useState("")
  const [editorDesc, setEditorDesc] = useState("")
  const [showAlert, setShowAlert] = useRecoilState(blogAlert);
  const [response, setResponse] = useRecoilState(blogResponse)
  const [uploadImage, setUploadImage] = useState(false)
  const setRefresh = useSetRecoilState(blogRefresh)
  const [form] = Form.useForm()
  const { confirm } = Modal;
  // const blogx = blogs?.blog && blogs?.blog
  const data = blogs || {}
  const {blog, top, productCategories} = data || {}
//   const featureList = data?.homeFeatures
//   const unique = featureList && featureList.filter(f => f.type == "unique")
  const { Option } = Select;

  const confirmAction = (id, action) => {
    confirm({
      title: `Are you sure you want to ${action} this Contact?`,
      icon: <FontAwesomeIcon icon={faExclamation} color="primary" />,
      content: 'Click Ok to continue',
      onOk() {
        handleShowHide(id, action.toLowerCase())
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }
  const onEditorStateChange = editorState => {
    setEditor(editorState);
  };
  const onEditorStateChanges = editorState => {
    setEditorDesc(editorState);
  };
  const handleUpdate = () => {
    const titleState = getRawData(top?.title?? '')
    const contentState = getRawData(top?.description?? '')
    setEditor(EditorState.createWithContent(titleState));
      setEditorDesc(EditorState.createWithContent(contentState));
      setViewTopModal(true)
  }

  const handleShowHide = async (id, type) => {
    const date = new Date()
    const res = await updateFeature({ data: {}, type, id })
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
    }
  }

  const onFinish = async (val) => {
    setLoading(true)
    const date = new Date()
    const fd = new FormData();
    fd.append('type', val.type)
    fd.append('title', val.title)
    fd.append('description', val.description)
    // fd.append('title', getHtml(editor))
    // fd.append('description', getHtml(editorDesc))
    const res = await createBlogs(fd)
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
      setViewModal(false)
      form.resetFields()
      setEditor('')
      setEditorDesc('')
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
      setEditor('')
      setEditorDesc('')
      form.resetFields()
    }
    setLoading(false)
    form.resetFields()
  }

  const onUpdateFinish = async (val) => {
    setLoading(true)
    const date = new Date()
    const fd = new FormData();
    fd.append('title', getHtml(editor))
    fd.append('description', getHtml(editorDesc))
    fd.append('id', val.id)
    fd.append('type', val.type)
    const res = await updateBlogTop(fd)
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
      setViewTopModal(false)
      setEditorDesc('')
      setEditor('')
      form.resetFields()
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
      form.resetFields()
      setEditorDesc('')
      setEditor('')
    }
    setLoading(false)
    form.resetFields()
  }  

  const onFinishUpdate = async (val) => {
    setLoading(true)
    const date = new Date()
    const fd = new FormData();
    fd.append('title', val.title)
    fd.append('description', val.description)
    fd.append('type', val.type)
    fd.append('id', val.id)
    fd.append('image_url', val.image_url)
    fd.append('feature_image', file);
    const res = await updateFeature({ data: fd, type: "update", id: val.id })
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
      setEditModal(false)
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
    }
    setLoading(false)
  }

  const handleUpdateModal = (val) => {
    setEditModal(true)
    setValue(val)
  }

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  const handleChange = info => {
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, imageUrl => {
        setFile(info.file.originFileObj)
      });
    }
  };
  return (
    <div>
      <AlertToast showAlert={showAlert} setShowAlert={setShowAlert} response={response} page="Home" />
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
            <Breadcrumb.Item><FontAwesomeIcon icon={faHome} /></Breadcrumb.Item>
            <Breadcrumb.Item>Waya pay</Breadcrumb.Item>
            <Breadcrumb.Item active>Blogs</Breadcrumb.Item>
          </Breadcrumb>
          <h4>Blog Categories</h4>
        </div>
        <div className="table-settings mb-4">
          <Button variant="secondary" className="text-white me-3" onClick={() => handleUpdate()}>
            Update Blog Top <FontAwesomeIcon icon={faAddressCard} className="d-none d-sm-inline ms-1" />
          </Button>
          <Button variant="success" className="text-white me-3" onClick={() => setViewModal(true)}>
            Create Category <FontAwesomeIcon icon={faHome} className="d-none d-sm-inline ms-1" />
          </Button>
        </div>
      </div>
      <Row>
        {data && data.length === 0 ? <Empty />:
          <>
            <Col xs={12} md={12} xl={12} lg={12} key={top?.id}>
              <BlogCardHome key={top?.id} img={top?.image_url} description={top?.description} title={top?.title}
                id={top?.id} status={top?.status} blogList={top?.blogList} name='top'
              />
            </Col>
            {blog && blog?.map((ex, i) =>
              <Col xs={12} md={6} xl={6} lg={6} key={ex.id}>
                <BlogCardHome key={ex.id} img={ex.image_url} description={ex.description} title={ex.title}
                  id={ex.id} status={ex.status} blogList={ex.blogList} index={i}
                />
              </Col>
            )}
          </>
        }
      </Row>

      {/*create feature start */}
      <Modal
        title="Create Category"
        centered
        visible={viewModal}
        footer={null}
        onCancel={() => setViewModal(false)}
      >
        <Form form={form} onFinish={onFinish} layout="vertical">
          <Form.Item label="Title" name="title" rules={[{ required: true }]}>
            <Input />
            {/* <Editor
              editorState={editor}
              editorClassName="px-3 border border-gray-1"
              editorStyle={{
                height: 130,
                overflow: 'auto',
              }}
              onEditorStateChange={onEditorStateChange}
            /> */}
          </Form.Item>
          <Form.Item name="type" hidden initialValue='blog'>
            <Input hidden />
          </Form.Item>
          <Form.Item label="Description" name="description" rules={[{ required: true }]}>
            <Input.TextArea />
            {/* <Editor
              editorState={editor}
              editorClassName="px-3 border border-gray-1"
              editorStyle={{
                height: 130,
                overflow: 'auto',
              }}
              onEditorStateChange={onEditorStateChanges}
            /> */}
          </Form.Item>
          <Form.Item>
            <AntButton type="primary" htmlType="submit" loading={loading}>
              Create
            </AntButton>
          </Form.Item>
        </Form>
      </Modal>
      {/*create feature end */}
      {/*create feature start */}
      <Modal
        title="Update Top Blog"
        centered
        visible={viewTopModal}
        footer={null}
        onCancel={() => setViewTopModal(false)}
      >
        <Form form={form} onFinish={onUpdateFinish} layout="vertical">
          <Form.Item label="Title" name="title" rules={[{ required: true }]}>
            {/* <Input /> */}
            <div onClick={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()}>
              <Editor
                wrapperId="blog-top-title-editor"
                editorState={editor}
                editorClassName="px-3 border border-gray-1"
                editorStyle={{
                  height: 100,
                  overflow: 'auto',
                }}
                onEditorStateChange={onEditorStateChange}
              />
            </div>
          </Form.Item>
          <Form.Item hidden name="id" initialValue={top?.id}>
            <Input hidden />
          </Form.Item>
          <Form.Item hidden name="type" initialValue='top'>
            <Input hidden />
          </Form.Item>
          <Form.Item label="Description" name="description">
            {/* <Input.TextArea /> */}
            <div onClick={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()}>
              <Editor
                wrapperId="blog-top-desc-editor"
                editorState={editorDesc}
                editorClassName="px-3 border border-gray-1"
                editorStyle={{
                  height: 150,
                  overflow: 'auto',
                }}
                onEditorStateChange={onEditorStateChanges}
              />
            </div>
          </Form.Item>
          <Form.Item>
            <AntButton type="primary" htmlType="submit" loading={loading}>
              Update
            </AntButton>
          </Form.Item>
        </Form>
      </Modal>
      {/*create feature end */}

      {/* update feature start */}
      <Modal
        title="Update Feature"
        centered
        visible={editModal}
        footer={null}
        onCancel={() => setEditModal(false)}
      >
        <Form form={form} onFinish={onFinishUpdate} layout="vertical" initialValues={{ title: value.title, description: value.description, id: value.id, image_url: value.image_url, type: value.type }}>
          <Form.Item label="Title" name="title" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item label="Description" name="description" rules={[{ required: true }]}>
            <Input.TextArea />
          </Form.Item>
          <Form.Item label="Type" name="type" rules={[{ required: true }]}>
            <Select onChange={(v) => { if (v == "home") { setUploadImage(false) } else { setUploadImage(true) } }}>
              <Option value="explore">Explore Feature</Option>
              <Option value="unique">Unique Feature</Option>
              <Option value="home">Home Feature</Option>
              <Option value="w-pos">Web Pos</Option>
              <Option value="t-pos">Terminal Pos</Option>
              <Option value="amazing">Amazing Feature</Option>
            </Select>
          </Form.Item>
          <Form.Item name="id" hidden>
            <Input />
          </Form.Item>
          {uploadImage &&
            <Form.Item >
              <Upload onChange={handleChange} customRequest={dummyRequest} maxCount={1}>
                <AntButton icon={<InboxOutlined />}>Upload Feature Image</AntButton>
              </Upload>
            </Form.Item>}
          <Form.Item>
            <AntButton type="primary" htmlType="submit" loading={loading}>
              Update
            </AntButton>
          </Form.Item>
        </Form>
      </Modal>
      {/* update feature end */}
    </div>
  )
}

export default BlogIndex
